export default {
    "estimate": {
        "data": {
            "title": "O seu telhado apresenta:",
            "kwh_m2_per_year": {
                "name": "kWh/m² por ano",
                "descr": "(com base na análise 3D dos telhados)"
            },
            "area_for_solar_panels": {
                "name": "m² disponíveis para painéis solares",
                "descr": "(com base na análise 3D dos telhados)"
            },
            "savings": {
                "name": "{value} € em poupanças",
                "descr": "Estimadas por um período de 25 anos."
            },
        },
        "custom_estimate": {
            "title": "Detalhar Estimativa",
            "confirm-calculate": "Pretende efetuar o cálculo do potencial da produção solar da cobertura seleccionada para os parâmetros indicados?",
        },
        "data_consumed": {
            "title": "Dados de Consumo",
        },
        "msg": {
            "noResidentialType": "O edifício selecionado tem um uso exclusivamente não residencial.",
        },
        "error": {

        },
    }
}
